import { useEffect } from "react";
import usePagination from "./usePagination";
import { IIndexParamsPmv, IPmv } from "../models/Pmv";
import { indexPMV } from "../api/its/pmv";

const usePMV = ({
    package_id,
    page: defaultPage,
    pageSize: defaultPageSize
}: IIndexParamsPmv): ReturnType<typeof usePagination<IPmv>> => {

    const hookPmv = usePagination<IPmv>({ pageSize: defaultPageSize, page: defaultPage });
    const { page, pageSize } = hookPmv;

    useEffect(() => {
        const getPMV = async () => {
            hookPmv.loadingStart();
            const { data, totalItems } = await indexPMV({
                package_id,
                page,
                pageSize
            });
            hookPmv.setData(data);
            hookPmv.setTotalItems(totalItems)
            hookPmv.loadingEnd();
        }
        getPMV();
    }, [page, pageSize, package_id]);

    return hookPmv;
}

export default usePMV;